<template>
  <div class="app-container">
    <div style="margin-bottom: 10px;">
      <el-button type="primary" style="margin-left: 4px;" @click="newAdd" :disabled="!canWrite">新增</el-button>
      <el-button type="primary" style="margin-left: 4px;" @click="save" :disabled="Status === 2 || !canWrite">保存</el-button>
      <el-button type="primary" style="margin-left: 4px;" :disabled="!isSave || Status === 2 || !canWrite"  @click="handleDelete">删除</el-button>
       <el-button
        type="primary"
        style="margin-left: 4px"
        @click="reView"
        v-if="Status !== 2"
        :disabled="!isSave || !canReview"
        >审核</el-button
      >
      <el-button
        type="primary"
        style="margin-left: 4px"
        @click="cancelReView"
        v-if="Status === 2"
        :disabled="!isSave || !canReview"
        >弃审</el-button
      >
      <el-button type="primary" style="margin-left: 4px;" :disabled="!isSave">打印</el-button>
    </div>
    <el-form
      :model="data"
      ref="form"
      :inline="true"
      :line-form="true"
      label-width="100px"
      status-icon
    >
      <el-row style="margin-top: 18px;">
        <el-form-item label="单据日期:" required>
           <span class="not-edit" v-if="Status === 2">{{ data.DocDate }}</span>
           <el-date-picker v-else v-model="data.DocDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
              placeholder="选择日期" style="width:180px" @change="(v) => getPreviewNo(v)">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="单据编码:" required>
          <span
            style="display:inline-block;width:180px;"
            v-if="Mode == 0"
            class="detail-span"
            >{{ data.DocNo }}</span
          >
          <el-input
            style="width:180px"
            v-else
            v-model="data.DocNo"
            placeholder="请输入单据编码"  
          ></el-input>
        </el-form-item>
        <el-form-item label="业务类型:" label-width="100px">
          <span class="not-edit" style="width: 180px" v-if="Status === 2">{{
            data.BusinessType
          }}</span>
          <!-- <business-select
            v-else
            v-model="data.BusinessTypeId"
            style="width: 190px"
          /> -->
           <el-select
            v-else
            v-model="data.BusinessTypeId"
            style="width: 180px"
          >
            <el-option  @click.native="BusinessChange(item)" v-for="item in businessTypeList" :key="item.BusinessTypeId"  :label="item.BusinessType" :value="item.BusinessTypeId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调出仓库:" required>
          <span class="not-edit" v-if="Status === 2">{{
            data.OutWarehouseName
          }}</span>
          <el-select v-else style="width:180px" v-model="data.OutWarehouseId" @change="changeOutWarehouse" filterable>
            <el-option
              v-for="item in warehouseList"
              :key="item.key"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调入仓库:" required>
           <span class="not-edit" v-if="Status === 2">{{
            data.InWarehouseName
          }}</span>
          <el-select v-else style="width:180px" v-model="data.InWarehouseId" @change="changeInWarehouse" filterable>
            <el-option
              v-for="item in warehouseList"
              :key="item.key"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="制单人:">
          <span class="span" style="width:180px;">{{data.MakeEmpName}}</span>
        </el-form-item>
      </el-row>
      <el-row>
        <el-col :span="24">
        <el-form-item label="备注:" label-width="100px">
          <el-input
            type="textarea"
            v-model="data.Remark"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="60"
            placeholder="请填写备注信息"
            :disabled="Status === 2"
            style="width: 600px"
          />
        </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-table
      border
      class="table_bottom table-line tb-c-head"
      :data="tableData"
      :row-class-name="tableRowClassName"
      stripe
      style="margin-top: 18px;"
      @row-click="add"
      v-keymove="newLine"
      :summary-method="summaryFunc" 
      show-summary
    >
     <insert-row @on-insert="onInsert" />
     <el-table-column min-width="160" align="left" label="备注">
            <template slot-scope="{ row }">
              <span v-if="Status === 2">{{
                row.Remark
              }}</span>
              <el-input
                v-else
                v-model="row.Remark"
                @change="editT(row)"
                placeholder="请输入备注"
              />
            </template>
          </el-table-column>
     <el-table-column label="存货名称" prop="ProductName" align="left" min-width="100">
          <template slot-scope="{ row }">
          <span class="not-edit" v-if="Status === 2">{{
            row.ProductName
          }}</span>
          <account-select
            v-else
            v-model="row.ProductName"
            :source="DAccount"
            @select="onSelect($event,row)"
            :pageSize="pageParams.pageSize"
            :pageIndex="pageParams.pageIndex"
            :listTotal='listTotal'
            @inputText="inputText($event, row)"
            @click.native="resetFun"
            @currentPage="currentPage($event, row)"
            :pageType='true'
          /> 
        </template>
      </el-table-column>
      <el-table-column align="left" label="批号" min-width="300px" >
        <template slot-scope="{ row, $index }">
          <span v-if="!row.ProductName" style="color:#999;">请先选择存货</span>
          <span class="not-edit" v-else-if="Status === 2">{{row.BatchNumber}}</span>
          <span v-else-if="!row.IsBatchNumber" class="text-gray">该存货未启用批号</span>
          <account-select v-else 
            v-model="row.BatchNumber" 
            :Head='Head'
            :source="batchList"
            :listTotal="batchListTotal" :pageType="true" 
            :pageSize="batchPageParams.pageSize" :pageIndex="batchPageParams.pageIndex"
            @select="onSelBatch($event, row, $index)" 
            @inputText="inputTextBatch($event, row)" 
            @click.native="onOpenBatch($event, row, $index)" 
            @currentPage="currentPageBatch($event, row)" 
            keyword="BatchNumber"/>
        </template>
      </el-table-column>
      <el-table-column label="存货编码" prop="ProductNo" align="left" min-width="160">
      </el-table-column>
      <el-table-column label="规格型号" prop="ProductSpec" align="left" min-width="100">
      </el-table-column>
      <el-table-column
        label="属性"
        prop="PropertyId"
        align="left"
        min-width="100"
        key="table1_6"
      >
        <template slot-scope="{ row }">
          <el-select
            v-if="row.UseProcess && Status !== 2"
            v-model="row.PropertyId"
            @change="changeProperty($event, row)"
          >
            <el-option
              v-for="item in propertyList"
              :key="item.PropertyId"
              :label="item.PropertyName"
              :value="item.PropertyId"
            ></el-option>
          </el-select>
          <span class="not-edit" v-else>{{
            row.UseProcess ? row.PropertyName : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="颜色"
        prop="ColorId"
        align="left"
        min-width="100"
        key="table1_7"
      >
        <template slot-scope="{ row }">
          <el-select
            v-if="row.UseColor && Status !== 2"
            v-model="row.ColorId"
            @change="changeColor($event, row)"
          >
            <el-option
              v-for="item in row.Colors"
              :key="item.ColorId"
              :label="item.ColorName"
              :value="item.ColorId"
              :disabled="item.Status==0"
            ></el-option>
          </el-select>
          <span
            class="not-edit"
            v-else
            >{{ row.UseColor ? row.ColorName : ""}}</span
          >
        </template>
      </el-table-column> 
      <el-table-column align="left" label="计量单位" min-width="120px">
            <template slot-scope="{ row,$index}">
              <el-select
             v-if="row.Units && row.Units.length > 0&& row.HasGrammage != true"
             v-model="row.UnitId"
             :disabled="Status === 2"
           >
             <el-option
               v-for="item in row.Units"
               :key="item.UnitId"
               :value="item.UnitId"
               :label="item.UnitName"
               @click.native="compareSaUnit(item, row, $index)"
             ></el-option>
           </el-select>
           <span v-else>{{ row.UnitName}}</span>
            </template>
            <!--  -->
          </el-table-column>
        <el-table-column align="left" label="计量单位2" min-width="120px">
            <template slot-scope="{ row, $index }">
              <!-- <span>{{ row }}{{ $index }}</span> -->
              <el-select
                v-if="row.Units && row.Units.length > 0&& row.HasGrammage != true"
                v-model="row.UnitId2"
                :disabled="Status === 2"
              >
                <el-option
                  v-for="item in row.Units"
                  :key="item.UnitId"
                  :value="item.UnitId"
                  :label="item.UnitName"
                  @click.native="compareUnitId(item, row, $index)"
                ></el-option>
              </el-select>
              <span v-else-if="row.UnitType==0"></span>
              <span v-else>{{ row.UnitName2 }}</span>
            </template>
          </el-table-column>
      <el-table-column align="right" label="换算率">
        <template slot-scope="{ row, $index }">
          <span
            v-if="(Status === 2 || row.ChangeType === 0) && row.UnitType == 1"
            >{{ row.Rate }}</span
          >
          <span v-else-if="row.UnitType == 0"></span>
          <el-input
            v-else
            type="text"
            v-model="row.Rate"
            @input="RateChange($event, row, $index)"
          ></el-input>
        </template>
      </el-table-column>
       <el-table-column
        label="数量"
        prop="Quantity"
        align="right"
        min-width="100"
      >
        <template slot-scope="{ row,$index}">
          <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Quantity) }}</span>
          <el-input
            v-else
            type="text"
            v-model="row.Quantity"
            @change="changeQuantity($event, row,$index)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="数量2"
        prop="Quantity2"
        align="right"
        min-width="100"
      >
        <template slot-scope="{ row,$index }">
          <span class="not-edit" v-if="Status === 2">{{
             $commonJs.toThousands(row.Quantity2)
          }}</span>
          <el-input
            v-else
            v-show="row.UnitId2 || (row.Units2 && row.Units2.length !== 0)"
            type="text"
            v-model="row.Quantity2"
            @change="changeQuantity2($event, row,$index)"
          ></el-input>
        </template>
      </el-table-column>
    
      <el-table-column
        label="调出仓现存量"
        prop="OutExistQuantity"
        align="right"
        min-width="100"
      >
      </el-table-column>
      <el-table-column
        label="调入仓现存量"
        prop="InExistQuantity"
        align="right"
        min-width="100"
      >
      </el-table-column>
       <!-- <el-table-column label="调入单价" prop="InPrice" align="center" min-width="100">
          <template slot-scope="{ row }">
          <span class="not-edit" v-if="Status === 2 || data.AllotType === 0">{{ row.InPrice }}</span>
           <el-input type="text" v-else  v-model="row.InPrice"  @change="changeInPrice($event, row)"></el-input>
        </template>
      </el-table-column> -->
      <el-table-column label="调出单价" prop="OutPrice" align="right" min-width="100" v-if="canPrice">
        <template slot-scope="{ row }">
          <span class="not-edit" v-if="Status === 2">{{ row.OutPrice }}</span>
          <el-input
            type="number"
            v-else
            v-model="row.OutPrice"
            @change="changePrice($event, row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="调出单价2"
        prop="OutPrice2"
        align="right"
        min-width="100"
         v-if="canPrice"
      >
        <template slot-scope="{ row }">
          <span class="not-edit" v-if="Status === 2">{{ row.OutPrice2 }}</span>
          <el-input
            type="text"
            v-else
            v-model="row.OutPrice2"
            @change="changePrice2($event, row)"
          ></el-input>
        </template>
      </el-table-column>
      <!-- <el-table-column label="调入金额" prop="InAmount" align="center" min-width="100">
          <template slot-scope="{ row }">
          <span class="not-edit" v-if="Status === 2 || data.AllotType === 0">{{ row.InAmount }}</span>
           <el-input type="text" v-else  v-model="row.InAmount"  @change="changeInAmount($event, row)"></el-input>
        </template>
      </el-table-column> -->
      <el-table-column label="调出金额" prop="OutAmount" align="right" min-width="100" v-if="canPrice">
          <template slot-scope="{ row }">
          <span class="not-edit" v-if="Status === 2 ">{{ $commonJs.toThousands(row.OutAmount)}}</span>
           <el-input type="text" v-else  v-model="row.OutAmount" @change="changeAmount($event, row)"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="80">
        <template slot-scope="{ row, $index }">
          <el-button type="text" @click="del(row, $index)">删除</el-button>
        </template>
      </el-table-column>
       
    </el-table>

    <div class="mtx10">
      <div class="flex space-between">
        <div class="flex flex1">
          <div class="mrx18 center el-form-item__label">审核人</div>
          <div class="center el-form-item__label">{{data.ReviewEmpName}}</div>
        </div>
        <div class="flex flex1">
          <div class="mrx18 center el-form-item__label">审核时间</div>
          <div class="center el-form-item__label">{{data.ReviewTime}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import accountSelect from "@/components/business/stock/select";
import optionMixins from "@/mixins/option";


export default {
  mixins: [optionMixins],
  name: "editinventorytransfers",
  components: {
    accountSelect
  },
  data() {
    return {
      keepData: [],
      pdApi: require("@/api/ba/product").default,
      warehouseApi: require("@/api/ba/warehouse").default,
      businessTypeApi: require("@/api/ba/businessType").default,
      code_api: require("@/api/sy/serialCode").default,
      api: require("@/api/stock/stAllotDoc").default,
      propertyApi: require("@/api/ba/property").default,
      sourceTypeApi:require("@/api/ba/sourceType").default,
      propertyList: [],
      Mode: 0,
      businessTypeList: [],
      warehouseList: [],
      initDAccount:[],
      initTotal:0,
      DAccount: [],
      listTotal:0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      isSave: false,
      Status: 0,
      data: {
        DocId: 0,
        DocDate: this.$commonJs.getToday(),
        DocNo: "",
        InWarehouseId: null,
        OutWarehouseId: null,
        InWarehouseName: "",
        OutWarehouseName: "",
        EmpName: "",
        EmpId: 0,
        MakeEmpName: "",
        MakeEmpId: 0,
        ReviewEmpName: "",
        ReviewEmpId: 0,
        MinusEntry:'',
        ReviewTime: "",
        AllotType: 0,
        Remark: "",
        BusinessTypeId: 0,
      },
      date: [],
      tableData: [
        {
          T: 0,
          DocId: 0,
          DocProductId: 0,
          ProductId: null,
          ProductName: "",
          ProductNo: "",
          ProductSpec: "",
          PropertyId: null,
          PropertyName: "",
          ColorId: null,
          ColorName: "",
          Colors: [],
          UnitId: null,
          UnitName: "",
          Units: [],
          Quantity: null,
          InAmount: null,
          OutAmount: null,
          InExistQuantity: null,
          OutExistQuantity: null,
          InPrice: null,
          OutPrice: null,

          UnitId2: 0,
          UnitName2: "",
          Quantity2: null,
          OutPrice2: null,
          Rate: null,
          Remark: "",
          BatchNumber:''

        },
      ],
      viewType: 'create',
      delTableData: [],
      isUseProcess: true,
      isUseColor: true,
      Head:[
        { Value: "BatchNumber", Name: "批号", Width: "180" },
        { Value: "WarehouseName", Name: "仓库", Width: "100" },
        { Value: "ColorName", Name: "颜色", Width: "80" },
        { Value: "PropertyName", Name: "属性", Width: "80" },
        // { Value: "BatchStartDate", Name: "批次起始日期", Width: "100" },
        // { Value: "ExpireDate", Name: "有效期至", Width: "100" },
        { Value: "BaseUnitName", Name: "主单位", Width: "80" }, 
        { Value: "BaseQuantity", Name: "现存量", Width: "80" }
      ],
      batchListTotal:0,
      batchPageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      batchList:[]
    };
  },
  created(){
    this.init();
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/business/stock/inventorytransfers");
    },
    canWrite() {
      return this.$permission.canWrite("/business/stock/inventorytransfers");
    },
    canReview() {
      return this.$permission.canReview("/business/stock/inventorytransfers");
    },
  },
  mounted() {
    this.viewType = this.$route.params.type;

    if (this.$route.params.type === "create") {
      this.getPreviewNo();
    } else if (this.$route.params.type === "edit") {
      this.editInit(this.$route.params.data);
    }
  },

  methods: {
    onInsert(e){
      let {type, index} = e;

      this.interpolate(null, index, type)
      
    },
    interpolate(row, index,type=""){
      let o = {
        T: 0,
        DocId: 0,
        DocProductId: 0,
        ProductId: null,
        ProductName: "",
        ProductNo: "",
        ProductSpec: "",
        PropertyId: null,
        PropertyName: "",
        ColorId: null,
        ColorName: "",
        Colors: [],
        UnitId: null,
        UnitName: "",
        Units: [],
        Quantity: 0,
        InAmount: 0,
        OutAmount: 0,
        OutExistQuantity: 0,
        InExistQuantity: 0,
        InPrice: 0,
        OutPrice: 0,
      };
      if(type=="down"){
        index=index+1;
      }
      this.tableData.splice(index, 0, o);
      let copy = JSON.parse(JSON.stringify(this.tableData));
      this.tableData = [];
      this.$nextTick(() => {
        this.tableData = copy;
      })
      console.log("this.tableData",this.tableData)
 
    },
    init(){
      this.propertyApi.list({
        Status: 1
      }).then(res => {

        if(res.Code === 0){
          this.propertyList = res.Data;
        }
      })

      this.pdApi
        .list({
          Status: 1,
          PageIndex: this.pageParams.pageIndex,
          pageSize: this.pageParams.pageSize,
        })
        .then((res) => {
          this.DAccount = res.Data;
          this.initDAccount = res.Data;
          this.listTotal = res.Count;
          this.initTotal = res.Count;
        });

      this.warehouseApi.list({ Status: 1 }).then((res) => {
        if (res.Code === 0) {
          this.warehouseList = res.Data.map((item) => {
            return {
              key: item.WarehouseId,
              label: item.WarehouseName,
              value: item.WarehouseId,
            };
          });
        }
      });
      this.sourceTypeApi.list({}).then(res=>{
       if(res.Code==0){
        this.SourceTypeIdArr=res.Data
        let params="库存调拨单"
        let index=  this.SourceTypeIdArr.findIndex(item=>item.SourceType==params)
        let SourceTypeId =this.SourceTypeIdArr[index].SourceTypeId
        this.businessTypeApi.getSourceTypeToBusinessType(SourceTypeId).then(res=>{
         if(res.Code==0){
          this.businessTypeList=res.Data
          if (this.viewType !== "edit") {
            this.data.BusinessTypeId =
              this.businessTypeList[0].BusinessTypeId;
            this.data.BusinessType =
              this.businessTypeList[0].BusinessType;
            this.data.MinusEntry = this.businessTypeList[0].MinusEntry;
            this.changeNumber(this.data.MinusEntry);
          } else {
            console.log(
              "this.data.BusinessTypeId",
              this.data.BusinessTypeId
            );
            let item = this.businessTypeList.filter((item) => {
              return item.BusinessTypeId === this.data.BusinessTypeId;
            })[0];

            console.log("item", item);

            this.data.MinusEntry = item.MinusEntry;

            this.changeNumber(this.data.MinusEntry);
          }
         }
        })
      }
      })
      this.callOptionApi()
    },
    BusinessChange(val){
      this.data.BusinessTypeId=val.BusinessTypeId
      this.data.MinusEntry=val.MinusEntry
      this.data.BusinessType=val.BusinessType
      this.changeNumber(this.data.MinusEntry)

      
    },
    changeNumber(status) {
      if (status) {
        this.tableData.forEach((item, index) => {
          item.Quantity = item.Quantity > 0 ? 0 - item.Quantity : item.Quantity;
          item.Quantity2 =
            item.Quantity2 > 0 ? 0 - item.Quantity2 : item.Quantity2;
            item.OutAmount = item.OutAmount == null ? item.OutAmount : item.Quantity * item.OutPrice;

          if (item.T !== 0) {
            item.T = 1;
          }
        });
      } else {
        this.tableData.forEach((item, index) => {

          item.Quantity = item.Quantity == null ? item.Quantity : Math.abs(item.Quantity) ;
          item.Quantity2 = item.Quantity2 == null ? item.Quantity2 : Math.abs(item.Quantity2) ;
          item.OutAmount = item.OutAmount == null ? item.OutAmount : item.Quantity * item.OutPrice;


          if (item.T !== 0) {
            item.T = 1;
          }
        });
      }
    },
    getPreviewNo(dateTime = "") {
      this.code_api.previewNo("调拨单", dateTime).then((res) => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取调拨单编号失败");
        }
      });
    },
    editInit(data, type = 'edit'){
      console.log('data', data)
      this.viewType = "edit";
      this.isSave = true;
      let {
        AllotType,
        DocDate,
        DocId,
        DocNo,
        EmpId,
        EmpName,
        InWarehouseId,
        InWarehouseName,
        MakeEmpId,
        MakeEmpName,
        OutWarehouseId,
        OutWarehouseName,
        Products,
        Remark,
        ReviewEmpId,
        ReviewEmpName,
        ReviewTime,
        Status,
        BusinessTypeId,
        BusinessType,

      } = data

      this.Status = Status;

      Products.forEach((item, index) => {
        item.T = null;
        item.IsBatchNumber = item.BatchNumber ? true : false
        item.PropertyId = item.PropertyId !== 0 ? item.PropertyId : null;
        item.ColorId = item.ColorId !== 0 ? item.ColorId : null;
        item.UnitId = item.UnitId !== 0 ? item.UnitId : null;
        item.Quantity2 = item.Quantity === null ? item.Quantity : 0;
        item.Rate = item.ChangeRate;

        if (item.Units.length === 0 || item.Units == null) {
          item.UnitType = 0;
          item.IsMain = true
        } else {
          item.UnitType = 1;
          let UnitItem = item.Units.filter((v) => {
            return item.UnitId === v.UnitId;
          })[0];
          item.IsMain = UnitItem.IsMain;
          item.Units.forEach(v=>{
            if(v.ChangeType==1)item.ChangeType=v.ChangeType
          })
        }
        if (type == 'keep') {
          item.ChangeType = this.keepData[index].ChangeType;
        }
        item.OutExistQuantity=item.IsMain ? item.OutExistQuantity : (item.OutExistQuantity / item.Rate).toFixed(5);
        item.InExistQuantity =item.IsMain ? item.InExistQuantity : (item.InExistQuantity / item.Rate).toFixed(5);   
      });


      this.tableData = Products;
      this.data = {
        AllotType,
        DocDate,
        DocId,
        DocNo,
        EmpId,
        EmpName,
        InWarehouseId,
        InWarehouseName,
        MakeEmpId,
        MakeEmpName,
        OutWarehouseId,
        OutWarehouseName,
        Remark,
        ReviewEmpId,
        ReviewEmpName,
        ReviewTime,
        BusinessTypeId,
        BusinessType,
      }

    },
    changeProperty(val, row){
      if (row.T !== 0) {
        row.T = 1;
      }

      let item = this.propertyList.filter((item) => {
        return item.PropertyId === val;
      })[0];

      row.PropertyName = item.PropertyName;
      row.PropertyId = item.PropertyId;
      this.getReferenceCost(row);
    },
    changeColor(val, row) {
      if (row.T !== 0) {
        row.T = 1;
      }
      let item = row.Colors.filter((item) => {
        return item.ColorId === val;
      })[0];

      row.ColorName = item.ColorName;
      row.ColorId = item.ColorId;
      this.getReferenceCost(row);

    },
    // changeUnit(val, row) {
    //   if (row.T !== 0) {
    //     row.T = 1;
    //   }

    //   let item = row.Units.filter((item) => {
    //     return item.UnitId === val;
    //   })[0];

    //   row.UnitName = item.UnitName;
    //   row.UnitId = item.UnitId;

    // },
    compareSaUnit(data, row, index) {
      if (row.T === 3) row.T = 1;

      this.editT(row);

      let lastIsMain = row.IsMain;
      this.tableData[index].IsMain = data.IsMain;
      let findIndex = 0;
      if (row.UnitId == row.UnitId2) {
        let num = 0;
        num = row.Quantity;
        row.Quantity = row.Quantity2;
        row.Quantity2 = num;

        if (data.IsMain) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units);
          this.changeRightUnitId(index, findIndex);
          // row.ChangeType1 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units);
          this.changeRightUnitId(index, findIndex);
          // row.ChangeType1 = data.ChangeType;
        }
      } else {
        if (data.IsMain) {
          findIndex = this.getUnitIndex(2, this.tableData[index].Units);
          this.changeRightUnitId(index, findIndex);
          // row.ChangeType1 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units);
          this.changeRightUnitId(index, findIndex, data.Rate);
          // row.ChangeType1 = data.ChangeType;
          if (lastIsMain) {
            row.Quantity2 = row.Quantity;
          }
          // row.Quantity = (row.Quantity2 / Number(data.Rate)).toFixed(2);
          row.Quantity = this.getQuantity(row.Quantity2 / Number(data.Rate));
        }
      }
      this.changeQuantity(this.tableData[index].Quantity, row, index, 1);

      this.getReferenceCost(row);

      let val = this.setNumber(Math.abs(row.OutAmount / row.Quantity));
      row.OutPrice = this.getPrice(val);

      val = this.setNumber(Math.abs(row.OutAmount / row.Quantity2));
      row.OutPrice2 = this.getPrice(val);
    },
    changeRightUnitId(index, findIndex, Rate = 0) {
      this.tableData[index].UnitId2 =
        this.tableData[index].Units[findIndex].UnitId;
      this.tableData[index].UnitName2 =
        this.tableData[index].Units[findIndex].UnitName;
      // this.tableData[index].ChangeType2 =
      //   this.tableData[index].Units[findIndex].ChangeType;

      if (Rate > 0) {
        this.tableData[index].Rate = Rate;
      }
    },
    changeQuantity(data, row, index, type = 0) {
      if (data == "-" || data == "." || data == "" || data == null || data == undefined) {
        return;
      }
      this.editT(row);
      data = this.setNumber(data)
      row.Quantity = this.getQuantity(data)
      if (this.data.MinusEntry) {
        row.Quantity > 0 ? (row.Quantity = 0 - row.Quantity) : row.Quantity;
        row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2;
        data = data > 0 ? 0 - data : data;
      } else {
        row.Quantity = Math.abs(row.Quantity);
        row.Quantity2 = Math.abs(row.Quantity2);
        data = Math.abs(data)
      }
      if (row.T == 3) this.tableData[index].T = 1;
      if (row.Units.length > 0) {
        if (row.IsMain) {
          // row.Quantity2= (row.Quantity / Number(row.Rate)).toFixed(2);
          //row.Quantity2 = this.getQuantity(row.Quantity / Number(row.Rate));
          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.Quantity * Number(row.Rate))
          } else {
            row.Quantity2 = this.getQuantity(row.Quantity / Number(row.Rate))
          }
          if (type === 0) {
            row.OutAmount = this.setAmount(row.OutPrice, row.Quantity);
            row.OutPrice2 = this.getPrice(Math.abs(row.OutAmount / row.Quantity2));
          }
        } else {
          //row.Quantity2 = this.getQuantity(data * Number(row.Rate));
          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.Quantity / row.Rate)
          } else {
            row.Quantity2 = this.getQuantity(row.Quantity * row.Rate)
          }
          if (type === 0) {
            row.OutAmount = this.setAmount(row.OutPrice, row.Quantity);
          }
          // if (row.ChangeType1 == 1 && row.Quantity2 != 0) {
          //   row.Rate = Math.abs(Number(row.Quantity2 / data)).toFixed(2);
          //   if (type === 0) {
          //     let val = this.setNumber(Math.abs(row.OutAmount / data));
          //     row.OutPrice = this.getPrice(val);
          //   }
          // } else if (row.Quantity2 == 0) {
          //   // row.Quantity2 = (data * Number(row.Rate)).toFixed(2);
          //   row.Quantity2 = this.getQuantity(data * Number(row.Rate));
          //   if (type === 0) {
          //     row.OutAmount = this.setAmount(row.OutPrice, row.Quantity);
          //   }
          // } else if (row.ChangeType1 == 0) {
          //   // row.Quantity2 = (data * Number(row.Rate)).toFixed(2);
          //   row.Quantity2 = this.getQuantity(data * Number(row.Rate));
          //   if (type === 0) {
          //     row.OutAmount = this.setAmount(row.OutPrice, row.Quantity);
          //   }
          // }
        }
      } else {
        row.Quantity2 = row.Quantity;
        row.OutAmount = this.setAmount(row.OutPrice, row.Quantity);
      }
    },
     
    compareUnitId(data, row, index) {
      if (row.T === 3) row.T = 1;

      this.editT(row);

      let lastIsMain = row.IsMain;
      if (data.IsMain) {
        this.tableData[index].IsMain = false;
      } else {
        this.tableData[index].IsMain = true;
      }
      let findIndex = 0;
      if (row.UnitId == row.UnitId2) {
        let num = 0;
        num = row.Quantity;
        row.Quantity = row.Quantity2;
        row.Quantity2 = num;

        if (this.tableData[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units);
          this.changeLeftUnitId(index, findIndex);
          // row.ChangeType2 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units);
          this.changeLeftUnitId(index, findIndex);
          // row.ChangeType2 = data.ChangeType;
        }
      } else {
        if (this.tableData[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units);
          this.changeLeftUnitId(index, findIndex);
          // row.ChangeType2 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units);
          this.changeLeftUnitId(index, findIndex, data.Rate);
          // row.ChangeType2 = data.ChangeType;
          if (!lastIsMain) {
            row.Quantity = row.Quantity2;
          }
          // row.Quantity2 = (row.Quantity / Number(data.Rate)).toFixed(2);
          row.Quantity2 = this.getQuantity(row.Quantity / Number(data.Rate));
        }
      }
      this.changeQuantity2(this.tableData[index].Quantity2, row, index, 1);

      this.getReferenceCost(row);

      let val = this.setNumber(Math.abs(row.OutAmount / row.Quantity));
      row.OutPrice = this.getPrice(val);

      val = this.setNumber(Math.abs(row.OutAmount / row.Quantity2));
      row.OutPrice2 = this.getPrice(val);
    },
    changeLeftUnitId(index, findIndex, Rate = 0) {
      this.tableData[index].UnitId =
        this.tableData[index].Units[findIndex].UnitId;
      this.tableData[index].SaUnitName =
        this.tableData[index].Units[findIndex].UnitName;
      // this.tableData[index].ChangeType1 =
      //   this.tableData[index].Units[findIndex].ChangeType;

      if (Rate > 0) {
        this.tableData[index].Rate = Rate;
      }
    },
    changeQuantity2(data, row, index, type = 0) {
      if (data == "-" || data == "." || data == "" || data == null || data == undefined) {
        return;
      }
      this.editT(row);
      // if(this.data.MinusEntry){
      //       row.Quantity2=0-row.Quantity2
      //      }else{
      //       row.Quantity2=Math.abs(row.Quantity2)
      //      }
      if (this.data.MinusEntry) {
        row.Quantity > 0 ? (row.Quantity = 0 - row.Quantity) : row.Quantity;
        row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2;
        data = data > 0 ? 0 - data : data;
      } else {
        row.Quantity = Math.abs(row.Quantity);
        row.Quantity2 = Math.abs(row.Quantity2);
        data = Math.abs(data)
      }
      if (row.T === 3) row.T = 1;
      if (row.IsMain == false) {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          //row.Rate = Math.abs(Number(data / row.Quantity)).toFixed(2);
          if (row.HasGrammage == true) {
            row.Quantity = this.getQuantity(data * row.Rate)
          } else {
            row.Rate = this.getIinvexchrate(data / row.Quantity)
          }
          if (type === 0) {
            let val = this.setNumber(Math.abs(row.OutAmount / data));
            row.OutPrice2 = this.getPrice(val);
          }
        } else {
          console.log("数量1=数量2/换算率");
          // row.Quantity=Number(data/row.Rate).toFixed(2);
          if(row.Quantity === 0){
            row.Quantity = this.getQuantity(data*row.Rate)
          }else{
            row.Quantity = this.getQuantity(data/row.Rate)
          }
          if (type === 0) {
            row.OutAmount = this.setAmount(row.OutPrice2, row.Quantity2);
          }
        }
      } else {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          //row.Rate = Math.abs(Number(row.Quantity / data)).toFixed(2);
          if (row.HasGrammage == true) {
            row.Quantity = this.getQuantity(data / row.Rate)
          } else {
            row.Rate = this.getIinvexchrate(row.Quantity / data)
          }
          if (type === 0) {
            let val = this.setNumber(Math.abs(row.OutAmount / data));
            row.OutPrice2 = this.getPrice(val);
          }
        } else {
          console.log("数量1=数量2*换算率");
          // row.Quantity=Number(data*row.Rate).toFixed(2);
          row.Quantity = this.getQuantity(data * row.Rate);
          if (type === 0) {
            row.OutAmount = this.setAmount(row.OutPrice2, row.Quantity2);
          }
        }
      }
    },
    //获取计量单位主辅单位的索引
    getUnitIndex(type, arr, id = "") {
      let index = 0;
      if (type == 1) {
        //获取主单位索引
        index = arr.findIndex((el) => el.IsMain == true);
      } else if (type == 2) {
        //获取数组第一个不是主单位的索引
        index = arr.findIndex((el) => el.IsMain == false);
      } else {
        //获取当前传入id的索引
        index = arr.findIndex((el) => id == el.UnitId);
      }
      return index;
    },
    getUnitValue(arr, findIndex) {
      let data = {};
      data.UnitId = arr[findIndex].UnitId;
      data.UnitName = arr[findIndex].UnitName;
      data.IsMain = arr[findIndex].IsMain;
      data.ChangeType = arr[findIndex].ChangeType;
      data.Rate = arr[findIndex].Rate;
      return data;
    },
     changePrice(val, row) {
      this.editT(row);

      val = this.setNumber(val);
      row.OutPrice = this.getPrice(val);
      row.OutAmount = this.setAmount(row.OutPrice, row.Quantity);

      if (row.UnitId2 && row.Quantity2 !== 0) {
        row.OutPrice2 = this.getPrice(row.OutAmount / row.Quantity2);
      }
    },
    changePrice2(val, row) {
      this.editT(row);

      val = this.setNumber(val);
      row.OutPrice2 = this.getPrice(val);

      row.OutAmount = this.setAmount(row.OutPrice2, row.Quantity2);
      if (row.Quantity !== 0) {
        row.OutPrice = this.getPrice(row.OutAmount / row.Quantity);
      }
    },
    editT(row) {
      if (row.T !== 0) {
        row.T = 1;
      }
    },
    changeAmount(val, row) {
      this.editT(row);

      // if (this.data.MinusEntry) {
      //   val = val > 0 ? 0 - val : val;
      // } else {
      //   val = Math.abs(val);
      // }
      row.OutAmount = this.setNumber(val);

      if (row.Quantity !== 0) {
        row.OutPrice = this.getPrice(Math.abs(row.OutAmount / row.Quantity));
      } else {
        this.$message({ type: "warning", message: "实收数量不能为0" });
        row.OutAmount = 0;
        return;
      }

      if (row.Quantity2 !== 0) {
        row.OutPrice2 = this.getPrice(Math.abs(row.OutAmount / row.Quantity2));
      } else {
        this.$message({ type: "warning", message: "实收数量2不能为0" });
        row.OutAmount = 0;
        return;
      }
    },
    RateChange(data, row, index) {
      if (data < 0 || data == "") return;
      if (row.T === 3) row.T = 1;
      row.Rate = data;
      row.Rate = Number(row.Rate).toFixed(5);
      // this.changeQuantity(this.tableData[index].Quantity,row,index)
      if (row.IsMain) {
        // row.Quantity2 = (row.Quantity / Number(data)).toFixed(2);
        if(row.HasGrammage==true){
   row.Quantity2 = this.getQuantity(row.Quantity * Number(data));
        }else{
          row.Quantity2 = this.getQuantity(row.Quantity / Number(data));
        }
      } else {
        // row.Quantity = (row.Quantity2 / Number(data)).toFixed(2);
        if(row.HasGrammage==true){

          row.Quantity = this.getQuantity(row.Quantity2 * Number(data));
        }else{

          row.Quantity = this.getQuantity(row.Quantity2 / Number(data));
        }
      }

      let val = this.setNumber(row.OutAmount / row.Quantity);
      row.OutPrice = this.getPrice(val);

      val = this.setNumber(row.OutAmount / row.Quantity2);
      row.OutPrice2 = this.getPrice(val);
    },
    setAmount(p, q) {
      return parseFloat((p * q).toFixed(2));
    },
    //切换调出仓库触发
    async changeOutWarehouse(val){
      let item = this.warehouseList.filter((item) => {
        return item.value === val;
      })[0];
   
      this.data.OutWarehouseId = item.value;
      this.data.OutWarehouseName = item.label;
      //OutWarehouseId  

      for (var i = 0; i < this.tableData.length; i++) {
        let o = {
          ProductId: this.tableData[i].ProductId, 
          InWarehouseId: this.data.InWarehouseId, 
          OutWarehouseId: this.data.OutWarehouseId,
          ColorId:this.tableData[i].ColorId,
          PropertyId:this.tableData[i].PropertyId,
        }
        o = this.$commonJs.obj.removeNullKey(o)
        var that = this
        await this.api.referenceCost(o).then(res => {
          if(res.Code === 0){
            that.tableData[i].OutExistQuantity=that.tableData[i].IsMain ? res.Data.OutExistQuantity : (res.Data.OutExistQuantity / that.tableData[i].Rate).toFixed(5);
            that.tableData[i].InExistQuantity =that.tableData[i].IsMain ? res.Data.InExistQuantity : (res.Data.InExistQuantity / that.tableData[i].Rate).toFixed(5);   
          }
        })
      }
      
    },
    //切换调入仓库触发
    async changeInWarehouse(val){
      let item = this.warehouseList.filter((item) => {
        return item.value === val;
      })[0];
      
      this.data.InWarehouseId = item.value;
      this.data.InWarehouseName = item.label;
      //InWarehouseId

      for (var i = 0; i < this.tableData.length; i++) {
        let o = {
          ProductId: this.tableData[i].ProductId, 
          InWarehouseId: this.data.InWarehouseId, 
          OutWarehouseId: this.data.OutWarehouseId,
          ColorId:this.tableData[i].ColorId,
          PropertyId:this.tableData[i].PropertyId,
        }
        o = this.$commonJs.obj.removeNullKey(o)
        var that = this
        await this.api.referenceCost(o).then(res => {
          if(res.Code === 0){
            that.tableData[i].OutExistQuantity=that.tableData[i].IsMain ? res.Data.OutExistQuantity : (res.Data.OutExistQuantity / that.tableData[i].Rate).toFixed(5);
            that.tableData[i].InExistQuantity =that.tableData[i].IsMain ? res.Data.InExistQuantity : (res.Data.InExistQuantity / that.tableData[i].Rate).toFixed(5);   
          }
        })
      }
    },
    changeInAmount(val, row){
      val = this.setNumber(val)
      row.InAmount = parseFloat(val.toFixed(2))
      if(row.Quantity !== 0){
        row.InPrice = parseFloat(this.getPrice(row.InAmount / row.Quantity)) 
      }
      

    },
    changeOutAmount(val, row){
      val = this.setNumber(val)
      row.OutAmount = parseFloat(val.toFixed(2))
      if(row.Quantity !== 0){
        row.OutPrice = parseFloat(this.getPrice(row.OutAmount / row.Quantity)) 
      }
      

    },
    changeInPrice(val, row){
      val = this.setNumber(val)
      row.InPrice = parseFloat(this.getPrice(val));
      row.InAmount = parseFloat((row.Quantity * row.InPrice).toFixed(2))
    },
    changeOutPrice(val, row){
      val = this.setNumber(val)
      row.OutPrice = parseFloat(this.getPrice(val));
      row.OutAmount = parseFloat((row.Quantity * row.OutPrice).toFixed(2))
    },
    onSelect(e,row){

        // if(this.data.InWarehouseId == null || this.data.OutWarehouseId == null){
        //   this.$message({type: 'warning', message: '请先填写调入仓库和调出仓库'})
        //   return
        // }

        if(row.T !== 0){
          row.T = 1;
        }

        row.IsBatchNumber = e.BatchNumber ?? false
        row.BatchNumber = null
        row.BatchStartDate = row.IsBatchNumber ? row.BatchStartDate : null
        row.Grammage= e.Grammage,
        row.HasGrammage= e.HasGrammage,
        row.Variable= e.Variable
        row.Colors = [];
        row.Units = [];

        row.ColorId = null;
        row.PropertyId = null;

        if(row.UnitId){
          row.UnitName = "";
          row.UnitId = null;
        }

        if(row.ColorId){
          row.ColorName = "";
          row.ColorId = null;
        }

        if(row.PropertyName){
          row.PropertyName = "";
          row.PropertyId = null
        }

        row.ProductName = e.ProductName;
        row.ProductNo = e.ProductNo;
        row.ProductId = e.ProductId;
        row.ProductSpec = e.ProductSpec;
        row.Colors = e.Colors;
        row.Units = e.Units;

        row.UseColor = e.UseColor;
        row.UseProcess = e.UseProcess;

      

        row.UnitId = e.SkUnitId;
        row.ChangeType = 0;
        row.UnitType = 0;

        if (e.Units.length === 0) {
        row.UnitId = e.SkUnitId;
        row.UnitName = e.SkUnitName;
        row.IsMain = true
      } else {
        console.log(row.UnitId, "row.UnitId");
        row.UnitType = 1;
        e.Units.forEach((item) => {
            if (item.ChangeType == 1) row.ChangeType = item.ChangeType;
          });
        if(row.UnitId){
          let index = this.getUnitIndex(3, e.Units, row.UnitId);
          let data = this.getUnitValue(e.Units, index);
          let assistIndex = 0;
          let assistData = {};
          row.IsMain = data.IsMain;
          row.UnitName=data.UnitName;
          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, e.Units);
            assistData = this.getUnitValue(e.Units, assistIndex);
            row.Rate = assistData.Rate.toFixed(5);
          } else {
            assistIndex = this.getUnitIndex(1, e.Units);
            assistData = this.getUnitValue(e.Units, assistIndex);
            row.Rate = data.Rate.toFixed(5);
          }
          row.UnitId2 = assistData.UnitId;
          row.UnitName2 = assistData.UnitName;
        }else{
          let untiLength = e.Units.length;
          let mainData = [];
          let noMainData = [];
          for(let i = 0; i < untiLength; ++i){
            if(e.Units[i].IsMain){
              mainData.push(e.Units[i])
            }else{
              noMainData.push(e.Units[i])
            }
          }
          row.UnitId = mainData[0].UnitId;
          row.UnitName = mainData[0].UnitName;
          row.UnitId2 = noMainData[0].UnitId;
          row.UnitName2 = noMainData[0].UnitName;
          row.Rate = noMainData[0].Rate.toFixed(5);
          row.IsMain = true;
        }
        
      }



      // this.api.referenceCost({ProductId: row.ProductId, InWarehouseId: this.data.InWarehouseId, OutWarehouseId: this.data.OutWarehouseId}).then(res => {
      //     if(res.Code === 0){
      //       row.InPrice = res.Data.InReferenceCost;
      //       row.OutPrice = res.Data.OutReferenceCost;
      //       row.OutExistQuantity=res.Data.OutExistQuantity
      //       row.InExistQuantity =res.Data.InExistQuantity     
      //     }
      //   })
      this.getReferenceCost(row);

    },
    getReferenceCost(data){
      let o = {
        ProductId: data.ProductId, 
        InWarehouseId: this.data.InWarehouseId, 
        OutWarehouseId: this.data.OutWarehouseId,
        ColorId:data.ColorId,
        PropertyId:data.PropertyId,
      }
      o = this.$commonJs.obj.removeNullKey(o)
      this.api.referenceCost(o).then(res => {
          if(res.Code === 0){
            data.InPrice = res.Data.InReferenceCost;
            data.OutPrice = res.Data.OutReferenceCost;
            console.log("🚀 ~ this.api.referenceCost ~ data.IsMain:", data.IsMain)

            // if(data.IsMain || data.IsMain === undefined){
            //   data.InExistQuantity = res.Data.InExistQuantity 
            //   data.OutExistQuantity= res.Data.OutExistQuantity 
            // }else{
            //   data.OutExistQuantity= (res.Data.OutExistQuantity / data.Rate).toFixed(5);
            //   data.InExistQuantity = (res.Data.InExistQuantity / data.Rate).toFixed(5);
            // }



            data.OutExistQuantity= data.IsMain ? res.Data.OutExistQuantity : (res.Data.OutExistQuantity / data.Rate).toFixed(5);
            data.InExistQuantity = data.IsMain ? res.Data.InExistQuantity : (res.Data.InExistQuantity / data.Rate).toFixed(5);

          }
        })
    },
    resetFun(){
      this.pageParams.pageIndex=1
      this.DAccount=this.initDAccount
      this.listTotal=this.initTotal
    },
    currentPage({val, text1}, row){
      
      this.pageParams.pageIndex=val
          this.pdApi.list({ pageIndex: val,pageSize:7, Status: 1, ProductName: text1}).then((res) => {
            if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal=res.Count
            }
      });
    },
    inputText(text, row){
      row.ProductName = text;
       this.pdApi.list({pageIndex:1,pageSize:7 ,ProductName:text, Status: 1,}).then((res) => {
            if (res.Code == 0) {
            this.DAccount = res.Data;
            
            this.listTotal=res.Count
            }
          });
    },
    openPage() {
      this.$router.push({
        name: "workList",
      });
    },
    del(row, index) {
      this.$confirm("确认删除这条数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        if (row.T !== 0) {
          row.T = 2;
          this.delTableData.push(row);
        }


        this.tableData.splice(index, 1);
        if (this.tableData.length === 0) {
          this.newLine();
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    newLine() {
      let o = {
        T: 0,
        DocId: 0,
        DocProductId: 0,
        ProductId: null,
        ProductName: "",
        ProductNo: "",
        ProductSpec: "",
        PropertyId: null,
        PropertyName: "",
        ColorId: null,
        ColorName: "",
        Colors: [],
        UnitId: null,
        UnitName: "",
        Units: [],
        Quantity: null,
        InAmount: null,
        OutAmount: null,
        OutExistQuantity: null,
        InExistQuantity: null,
        InPrice: null,
        OutPrice: null,

        UnitId2: null,
        UnitName2: "",
        Quantity2: null,
        OutPrice2: null,
        Rate: null,
        Remark: "",
        IsMain: true
      };

      this.tableData.push(o);
    },
    add(row, column) {
      if (column.label === "操作") {
        return;
      }
      if (row.index === this.tableData.length - 1) {
        this.newLine();
      }
    },
    getProducts(data) {
      let Products = [];
      data.forEach((item) => {
        let {
          T,
          DocId,
          DocProductId,
          ProductId,
          ProductName,
          ProductNo,
          ProductSpec,
          PropertyId,
          PropertyName,
          ColorId,
          ColorName,
          Colors,
          UnitId,
          UnitName,
          Units,
          Quantity,
          InAmount,
          OutAmount,
          InExistQuantity,
          OutExistQuantity,
          InPrice,
          OutPrice,

          UnitId2,
          UnitName2,
          Quantity2,
          OutPrice2,
          Rate,
          ChangeType,
          Remark,
          UseColor,
          UseProcess,
          BatchNumber
        } = item;

        PropertyId = PropertyId ? PropertyId : 0;
        ColorId = ColorId ? ColorId : 0;
        UnitId = UnitId ? UnitId : 0;

        let o = {
          T,
          DocId,
          DocProductId,
          ProductId,
          ProductName,
          ProductNo,
          ProductSpec,
          PropertyId,
          PropertyName,
          ColorId,
          ColorName,
          Colors,
          UnitId,
          UnitName,
          Units,
          Quantity,
          InAmount,
          OutAmount,
          InExistQuantity,
          OutExistQuantity,
          InPrice,
          OutPrice,

          UnitId2,
          UnitName2,
          Quantity2,
          OutPrice2,
          ChangeRate: Rate,
          ChangeType,
          Remark,
          UseColor,
          UseProcess,
          BatchNumber
        };

        Products.push(o);
      });

      return Products;
    },
    save(type = 0){
      //验证表单是否填写
      let yanzheng = ['DocDate','DocNo', 'BusinessTypeId', 'InWarehouseId', 'OutWarehouseId']
      for(let key in this.data){
        if(yanzheng.indexOf(key) !== -1 && (!this.data[key])){
          this.$message({type: 'warning', message: '表单未填写完整'})
          return;
        }
      }
      if(this.data.AllotType === "" || this.data.InWarehouseId == null || this.data.OutWarehouseId == null){
        this.$message({type: 'warning', message: '请先选择业务类型,调入仓库，调出仓库'})
        return
      }
      if(this.data.InWarehouseId==this.data.OutWarehouseId){
        this.$message({type: 'warning', message: '请选择调出仓库和调入仓库不为相同仓库'})
        return 
      }
      let Products = this.getProducts(this.tableData);
      this.keepData = Products;
      if( Products.length>0 && Products[0].ProductName!=''){  
      }else{
        this.$message({type: 'warning', message: '表单明细不能为空'})
        return 
      }
     
      Products = Products.concat(this.delTableData);

      Products = Products.filter((item) => {
        return item.T != null && item.ProductId !== 0 && item.ProductId != null;
      });

      let ProductsLength = Products.length;
      for(let i = 0; i < ProductsLength; ++i){
        if(Products[i].UseColor && Products[i].ColorId === 0){
          this.$message.error(`存货${Products[i].ProductName}未填写颜色`)
          return;
        }
        // if(Products[i].UseProcess && Products[i].PropertyId === 0){
        //   this.$message.error(`存货${Products[i].ProductName}未填写属性`)
        //   return;
        // }
        // if(Products[i].Quantity === 0 || Products[i].InPrice === 0 || Products[i].OutPrice === 0){
        //    this.$message({type: 'warning', message: '存货数量或价格不能为0'})
        //   return
        // }
      }

      let o = {
        Products,
        ...this.data,
      };

      this.api.save(o).then((res) => {
        if (res.Code === 0) {
          if (this.viewType === "create") {
            this.data.DocId = res.Data;
          }
          if(type !== 1){
            this.$message.success(res.Msg);
          }
          this.isSave = true;

          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              if(type === 1){
                this.reView1()
              }else{
                this.editInit(res.Data, 'keep');
              }
              
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    reView1() {
      let id = this.data.DocId;
      this.api.examine(id).then((res) => {
        if (res.Code === 0) {
          this.$message({ type: "success", message: res.Msg });
          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    reView() {
      this.save(1)
    },
    cancelReView() {
      let id = this.data.DocId;
      this.api.cancelExamine(id).then((res) => {
        if (res.Code === 0) {
          this.$message({ type: "success", message: res.Msg });
          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    handleDelete() {
      let Id = this.data.DocId;
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        this.api.delete({Id}).then((res) => {
          if (res.Code === 0) {
            this.$message({ type: "success", message: res.Msg });
            this.newAdd();
            // this.$emit('deleted')
          } else {
            this.$message({ type: "warning", message: res.Msg });
          }
        });
      });
    },
    newAdd(){
      if (!this.isSave) {
        this.$message({ type: "warning", message: "请先进行保存再操作" });
        return;
      } else {
        Object.assign(this.$data, this.$options.data.call(this));
        this.getPreviewNo();
        this.$route.params.type = "create";
        this.viewType = "create";
        this.init();
        this.isSave = false;
      }
    },
    summaryFunc(param) {
      const { columns, data } = param;
      const sums = [];
      const emptyColumns = ["WarehouseId", "ProductNo", "OutPrice", "ProductSpec", "PropertyId", "ColorId",'OutPrice2'];
      columns.forEach((column, index) => {
        if (index === 0) { sums[index] = '合计'; return; }
        if (index === 1) console.log('data', column, data)
        if (emptyColumns.includes(column.property)) {
          sums[index] = '';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          var v = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          //数量 getQuantity
          const arr1 = ["Quantity","Quantity2"];
          //金额 固定2位小数
          const arr2 = ["Amount", "TaxLimit", "TaxAmount", "DiscountAmount","CostPrice","CostAmount"];
          if (arr1.indexOf(column.property) != -1) {
            v = this.getQuantity(v);
          }
          if (arr2.indexOf(column.property) != -1) {
            v = v.toFixed(2);
            let vStr = v.toString().split('.');
            if (Number(vStr[1]) <= 0) v = vStr[0];
          }
          if(v > 0) {
            v = Number(v).toLocaleString();
          }
          sums[index] = v;
        }
        else {
          sums[index] = '';
        }
      });
      return sums;
    },
    /** 打开批号弹框 */
    onOpenBatch(e, row, index) {
      this.batchPageParams.pageIndex = 1;
      let o = {
        IsInOut:1,
        WarehouseId:this.data.OutWarehouseId,
        ProductId: row.ProductId,
        PropertyId:row.PropertyId,
        ColorId:row.colorId,
        pageIndex: 1,
        pageSize: 7,
      } 
      var params = this.$commonJs.obj.removeNullKey(o);
      this.pdApi.productBatchNumberList(params).then((res) => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item=>{
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          });
          this.batchListTotal = res.Count;
        }else {
          this.$message.error(res.Msg);
        }
      });
    },
    /** 选择批号 */
    onSelBatch(e, row, index){
      if (row.T !== 0) {
        row.T = 1
      }
      if(e.BatchNumber !== row.BatchNumber){
        this.tableData[index].BatchNumber = e.BatchNumber
      }
    },
    /** 输入批号 */
    inputTextBatch(text, row) {
      if (row.T !== 0) {
        row.T = 1
      }
      row.BatchNumber = text;
      //IsInOut 入库-0 出库-1
      let o = {
        IsInOut:1,
        WarehouseId:this.data.OutWarehouseId,
        ProductId: row.ProductId,
        PropertyId:row.PropertyId,
        ColorId:row.colorId,
        BatchNumber:row.BatchNumber,
        pageIndex: 1,
        pageSize: 7,
      } 
      var params = this.$commonJs.obj.removeNullKey(o);
      this.pdApi.productBatchNumberList(params).then((res) => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item=>{
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          });
          this.batchListTotal = res.Count;
        }else {
          this.$message.error(res.Msg);
        }
      });
    },
    /** 批号下一页 */
    currentPageBatch({ val, text1 }, row) {
      this.batchPageParams.pageIndex = val;
      let o = {
        IsInOut:1,
        WarehouseId:this.data.OutWarehouseId,
        ProductId: row.ProductId,
        PropertyId:row.PropertyId,
        ColorId:row.colorId,
        ProductName:row.ProductName,
        pageIndex: val,
        pageSize: 7,
      } 
      var params = this.$commonJs.obj.removeNullKey(o);
      this.pdApi.productBatchNumberList(params).then((res) => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item=>{
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          });
          this.batchListTotal = res.Count;
        }else {
          this.$message.error(res.Msg);
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.dropdown-item {
  padding: 6px;
}

.mtx10 {
  padding: 10px;
}

.flex {
  display: flex;
  .text {
    width: 60px;
  }
}
.space-between {
  justify-content: space-between;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex1 {
  flex: 1;
}

.mrx18 {
  margin-right: 18px;
}
.span {
  display: inline-block;
  width: 180px;
}

</style>
